import React from 'react';
import { motion, Variants } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Members from './components/Members';
import Services from './components/Services';
import FAQ from './components/FAQ';
import ContactUS from './components/ContactUs';
import Footer from './components/Footer';
import { LandingTranslationProvider } from './contexts/LandingTranslationContext';

const pageVariants: Variants = {
  initial: {
    opacity: 0,
    x: -20
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut" as const
    }
  },
  exit: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.3,
      ease: "easeIn" as const
    }
  }
};

const Landing = () => {
  return (
    <LandingTranslationProvider>
      <div className="min-h-screen bg-gradient-to-r from-[#F6EAD1] to-[#99BAD4] overflow-hidden">
        <Navbar />
        <motion.div
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <Hero />
          <Features />
          <Members />
          <Services />
          <FAQ />
          <ContactUS />
        </motion.div>
        <Footer />
      </div>
    </LandingTranslationProvider>
  );
};

export default Landing;